<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <p>
          <span>COPYRIGHT &copy; Maxwell777.com</span>
          <!-- <span>{{ new Date().getFullYear() }} </span> -->
          <!-- <a href="https://1.envato.market/vuexy_admin" target="_blank" rel="nofollow">Pixinvent</a> -->
          <!-- <span class="hidden sm:inline-block">, All rights Reserved</span> -->
          <!-- <span class="ml-3"></span> -->
        </p>
        <span class="md:flex hidden items-center">
            <span>Logout at <b>{{ datetime }}</b></span>
            <feather-icon v-if="hasInternet" icon="WifiIcon" svgClasses="stroke-current text-success w-6 h-6" class="ml-2" /> 
            <feather-icon v-else icon="WifiOffIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" /> 
            <!-- <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" /> -->
        </span>
    </footer>
</template>

<script>
import moment from 'moment'
export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String
    }
  },
  data(){
    return {
      hasInternet: navigator.onLine,
    }
  },
  computed: {
    datetime(){
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      if(userInfo && userInfo.Expired_at){
        let expired_time = userInfo.Expired_at
        return moment(new Date(expired_time*1000)).format('YYYY-MM-DD HH:mm:ss');
      }
      else{
        return ''
      }
    }
  },
  mounted(){
    let self = this
    window.addEventListener('offline', function(e) { 
      self.hasInternet = false
      console.log('offline'); 
    });

    window.addEventListener('online', function(e) { 
      self.hasInternet = true
      console.log('online'); 
    });
  }
}
</script>
